/* Ashen London theme JS v6.3.2 — production Shopify implementation.
   Cart uses Shopify's AJAX Cart API; search uses the Predictive Search
   API; quick-add fetches product JSON. No fake states anywhere. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var T = window.theme || { routes: {}, strings: {}, moneyFormat: '£{{amount}}' };

  function money(cents) {
    var val = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return T.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2)).replace(/<[^>]+>/g, '') || val;
  }
  function announce(msg) { var l = $('#live'); if (l) l.textContent = msg; }
  function escapeHTML(s) { return String(s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  /* ---------- toast (with optional action) ---------- */
  var toastTimer;
  function showToast(msg, actionLabel, actionFn) {
    var t = $('#toast'); if (!t) return;
    t.textContent = '';
    t.appendChild(document.createTextNode(msg));
    if (actionLabel && actionFn) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = actionLabel;
      b.onclick = function () { t.classList.remove('show'); actionFn(); };
      t.appendChild(b);
    }
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, actionLabel ? 5000 : 2400);
  }

  /* ---------- focus trap ---------- */
  var trapEl = null, lastFocus = null;
  function trapFocus(el) {
    lastFocus = document.activeElement; trapEl = el;
    var f = el.querySelectorAll('a[href],button:not(:disabled),input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if (f.length) setTimeout(function () { f[0].focus(); }, 60);
  }
  function releaseFocus() { trapEl = null; if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} } lastFocus = null; }
  document.addEventListener('keydown', function (e) {
    var zm = $('#zoomModal');
    if (zm && zm.classList.contains('open')) {
      if (e.key === 'Escape') { closeZoom(); return; }
      if (e.key === 'ArrowLeft') { stepZoom(-1); return; }
      if (e.key === 'ArrowRight') { stepZoom(1); return; }
    }
    if (e.key === 'Escape') { closeEverything(); return; }
    if (e.key !== 'Tab' || !trapEl) return;
    var f = $$('a[href],button:not(:disabled),input,select,textarea,[tabindex]:not([tabindex="-1"])', trapEl).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  /* ---------- drawers / modals ---------- */
  function openDrawer(el) {
    closeEverything();
    var s = $('#scrim'); if (s) s.classList.add('open');
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lock'); trapFocus(el);
  }
  function closeEverything() {
    $$('.drawer.open,.modal.open,.search-panel.open').forEach(function (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); });
    var s = $('#scrim'); if (s) s.classList.remove('open');
    var mb = $('.menu-btn'); if (mb) mb.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('lock');
    releaseFocus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]') || e.target.id === 'scrim') { closeEverything(); return; }
    var om = e.target.closest('[data-open-menu]'); if (om) { var d = $('#menuDrawer'); if (d) { openDrawer(d); om.setAttribute('aria-expanded', 'true'); } return; }
    var oc = e.target.closest('[data-open-cart]'); if (oc) { e.preventDefault(); openCart(); return; }
    var of = e.target.closest('[data-open-filters]'); if (of) { var fd = $('#filterDrawer'); if (fd) openDrawer(fd); return; }
    var os = e.target.closest('[data-open-search]'); if (os) { openSearch(); return; }
    var sg = e.target.closest('[data-open-size-guide]'); if (sg) {
      var sm = $('#sizeModal');
      if (sm) {
        closeEverything();
        sm.classList.add('open');
        sm.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lock');
        trapFocus(sm.querySelector('.modal-card'));
      }
      return;
    }
    var mg = e.target.closest('[data-m-group] > button'); if (mg) { var g = mg.parentElement, open = g.classList.toggle('open'); mg.setAttribute('aria-expanded', open ? 'true' : 'false'); return; }
    var ac = e.target.closest('[data-accordion]'); if (ac) { var open2 = ac.parentElement.classList.toggle('open'); ac.setAttribute('aria-expanded', open2 ? 'true' : 'false'); return; }
  });

  /* ---------- home-page All / Men / Women tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-featured-tab]'); if (!tab) return;
    var section = tab.closest('[data-featured-section]'); if (!section) return;
    var key = tab.getAttribute('data-featured-tab');
    $$('[data-featured-tab]', section).forEach(function (button) {
      var active = button === tab;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    $$('[data-featured-panel]', section).forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-featured-panel') !== key;
    });
  });

  /* ---------- scrolled header ---------- */
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var h = $('.site-header'); if (h) h.classList.toggle('scrolled', window.scrollY > 8);
      ticking = false;
    });
  }, { passive: true });

  /* ---------- announcement rotation ---------- */
  (function () {
    var bar = $('.announcement'); if (!bar) return;
    var msgs = $$('[data-ann]', bar); if (msgs.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var idx = 0, interval = parseInt(bar.dataset.interval, 10) || 6000, timer;
    function start() {
      clearInterval(timer);
      timer = setInterval(function () {
        msgs[idx].classList.add('hide');
        idx = (idx + 1) % msgs.length;
        msgs[idx].classList.remove('hide');
      }, interval);
    }
    start();
  })();

  /* ---------- AJAX cart ---------- */
  function fetchCart() { return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }); }
  function updateBagCount(count) { var el = $('#bagCount'); if (el) el.textContent = count; }
  function renderCartDrawer(cart) {
    var body = $('#cartBody'), foot = $('#cartFoot'), progress = $('#shippingProgress');
    if (!body) return;
    updateBagCount(cart.item_count);
    if (progress) {
      var threshold = T.freeShippingThreshold || 0;
      if (threshold > 0 && cart.item_count > 0) {
        var left = Math.max(0, threshold - cart.total_price);
        progress.innerHTML = (left ? T.strings.progressLeft.replace('[amount]', '<b>' + money(left) + '</b>') : T.strings.progressDone) +
          '<div class="progress-track"><i style="width:' + Math.min(100, cart.total_price / threshold * 100) + '%"></i></div>';
      } else progress.innerHTML = '';
    }
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p>' + escapeHTML(T.strings.empty) + '</p><a class="button" style="margin-top:20px" href="' + T.routes.root + 'collections/all">' + escapeHTML(T.strings.startShopping) + '</a></div>';
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_200x$1$2') : '';
      return '<div class="cart-line">' +
        '<a class="cart-thumb" href="' + item.url + '">' + (img ? '<img src="' + img + '" alt="' + escapeHTML(item.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div><div class="cart-name"><a href="' + item.url + '">' + escapeHTML(item.product_title) + '</a></div>' +
        '<div class="cart-variant">' + escapeHTML(item.variant_title || '') + '</div>' +
        '<div class="qty" role="group" aria-label="Quantity for ' + escapeHTML(item.product_title) + '">' +
        '<button data-line="' + (i + 1) + '" data-line-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button data-line="' + (i + 1) + '" data-line-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<div class="line-actions"><button data-line="' + (i + 1) + '" data-line-qty="0" data-remove data-variant="' + item.variant_id + '" data-restore-qty="' + item.quantity + '">Remove</button></div></div>' +
        '<div class="cart-price">' + money(item.final_line_price) + '</div></div>';
    }).join('');
    foot.innerHTML = '<div class="total-row"><span>' + escapeHTML(T.strings.subtotal) + '</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<form action="' + T.routes.cart + '" method="post"><button class="button dark block" type="submit" name="checkout">' + escapeHTML(T.strings.checkout) + '</button></form>' +
      '<div class="checkout-note">' + escapeHTML(T.strings.checkoutNote) + '</div>';
  }
  function openCart() {
    var d = $('#cartDrawer'); if (!d) return;
    fetchCart().then(function (c) { renderCartDrawer(c); openDrawer(d); });
  }
  function changeLine(line, qty, removedInfo) {
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCartDrawer(cart);
      announce('Bag updated. ' + cart.item_count + ' items.');
      if (removedInfo) {
        showToast(T.strings.removed, T.strings.undo, function () {
          addToCart(removedInfo.variant, removedInfo.qty, true);
        });
      }
      return cart;
    });
  }
  function addToCart(variantId, qty, silent) {
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      return fetchCart().then(function (cart) {
        renderCartDrawer(cart);
        if (!silent) { showToast(T.strings.added); announce(T.strings.added + '. ' + cart.item_count + ' items in bag.'); }
        var d = $('#cartDrawer'); if (d && !d.classList.contains('open')) openCart();
        return cart;
      });
    }).catch(function (err) {
      showToast((err && err.description) || 'Could not add to bag');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line]');
    if (b) {
      var removed = b.hasAttribute('data-remove') ? { variant: b.getAttribute('data-variant'), qty: parseInt(b.getAttribute('data-restore-qty'), 10) } : null;
      changeLine(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-line-qty'), 10), removed);
    }
  });

  /* ---------- PDP: variant picker, qty, AJAX submit, sticky bar ---------- */
  (function () {
    var form = $('#ProductForm'); if (!form) return;
    var jsonEl = $('#ProductJson'); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var variantMedia = {};
    var variantMediaEl = $('#VariantMediaJson');
    if (variantMediaEl) {
      try { variantMedia = JSON.parse(variantMediaEl.textContent) || {}; } catch (e) { variantMedia = {}; }
    }
    var selected = [];
    var current = null;

    var swatchColours = {'navy': '#0b1f3a',
      'black':'#111111','white':'#ffffff','off white':'#f7f5ef','ivory':'#fffff0','ecru':'#f3ead8','cream':'#f5ead0','oatmeal':'#d8cbb5',
      'stone':'#b7afa3','taupe':'#8b7d72','beige':'#d6c4a8','nude':'#d8b49c','sand':'#cbb994','camel':'#b88955','tan':'#b78352',
      'brown':'#6f4e37','chocolate':'#4b2e24','espresso':'#2e211b','grey':'#8a8a88','gray':'#8a8a88','light grey':'#c7c7c5',
      'light gray':'#c7c7c5','dark grey':'#555553','dark gray':'#555553','charcoal':'#3f4142','silver':'#c0c0c0','navy':'#18253f',
      'navy blue':'#182b49','midnight blue':'#101a33','blue':'#315f9b','light blue':'#9fc5df','sky blue':'#78b7df','royal blue':'#2447a5',
      'cobalt':'#244abf','denim':'#4d648d','teal':'#1f6f70','turquoise':'#42b8b0','aqua':'#79d3d3','red':'#b3202a','crimson':'#9e1b32',
      'burgundy':'#6f1d2c','wine':'#722f37','maroon':'#641f2b','coral':'#e87968','orange':'#dc7134','rust':'#a84f2d','terracotta':'#bd6849',
      'yellow':'#e8ca4b','mustard':'#c79a2b','gold':'#c6a15b','green':'#3d764a','khaki':'#77754d','olive':'#6d7041','sage':'#9aa386',
      'forest green':'#244b36','emerald':'#247052','mint':'#a8d5ba','lime':'#91b84a','pink':'#dc93aa','blush':'#dfb2b5','rose':'#c97f8e',
      'dusty rose':'#b77d83','hot pink':'#dc4c82','fuchsia':'#b93478','purple':'#6c4b8e','plum':'#5f365f','lilac':'#b5a1cf',
      'lavender':'#aaa0cf','violet':'#7355a3','rose gold':'#b76e79','clear':'rgba(255,255,255,.55)','transparent':'rgba(255,255,255,.55)'
    };
    var swatchKeys = Object.keys(swatchColours).sort(function (a, b) { return b.length - a.length; });
    function normaliseColourName(name) {
      return String(name || '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    }
    function resolveSingleSwatch(name) {
      var normal = normaliseColourName(name);
      if (swatchColours[normal]) return swatchColours[normal];
      for (var i = 0; i < swatchKeys.length; i += 1) {
        if (normal.indexOf(swatchKeys[i]) !== -1) return swatchColours[swatchKeys[i]];
      }
      if (window.CSS && CSS.supports && CSS.supports('color', normal)) return normal;
      return '#c9c6bf';
    }
    function paintColourSwatches() {
      $$('.colour[data-swatch-name]', form).forEach(function (button) {
        if (button.style.getPropertyValue('--swatch') || button.style.getPropertyValue('--swatch-image')) return;
        var name = normaliseColourName(button.getAttribute('data-swatch-name'));
        if (/multi|rainbow|assorted/.test(name)) {
          button.style.setProperty('--swatch-image', 'conic-gradient(#bd3846,#d19a35,#5a8a62,#3e6ba7,#76508e,#bd3846)');
          return;
        }
        var parts = name.split(/\s*(?:\/|\+|&|,|\band\b)\s*/).filter(Boolean);
        if (parts.length > 1) {
          button.style.setProperty('--swatch-image', 'linear-gradient(135deg,' + resolveSingleSwatch(parts[0]) + ' 0 50%,' + resolveSingleSwatch(parts[1]) + ' 50% 100%)');
        } else {
          button.style.setProperty('--swatch', resolveSingleSwatch(name));
        }
      });
    }
    paintColourSwatches();

    product.variants.some(function (v) { if (String(v.id) === $('#VariantId').value) { selected = v.options.slice(); current = v; return true; } return false; });
    if (!selected.length && product.variants.length) { selected = product.variants[0].options.slice(); current = product.variants[0]; }

    function findVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      }) || null;
    }
    function refreshDisabled() {
      $$('.option-row').forEach(function (row) {
        var idx = parseInt(row.dataset.optionIndex, 10);
        $$('.pdp-size,.option-pill,.colour', row).forEach(function (btn) {
          var test = selected.slice(); test[idx] = btn.dataset.optionValue;
          var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
          var unavailable = !match || !match.available;
          btn.classList.toggle('disabled', unavailable);
          btn.disabled = unavailable;
          btn.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
        });
      });
    }
    function refreshUI() {
      current = findVariant();
      var add = $('#pdpAddBtn'), stock = $('#stockNote'), price = $('#pdpPrice'), vid = $('#VariantId'), sku = $('#skuLine');
      var skuWrap = $('#skuWrap'), sticky = $('#stickyAdd'), stickyBtn = sticky ? $('[data-sticky-add]', sticky) : null, stickyPrice = $('#stickyPrice'), stickyVariant = $('#stickyVariant');
      if (current) {
        vid.value = current.id;
        if (price) price.innerHTML = current.compare_at_price > current.price
          ? '<span class="price"><s>' + money(current.compare_at_price) + '</s><span class="sale">' + money(current.price) + '</span></span>'
          : '<span class="price">' + money(current.price) + '</span>';
        if (stickyPrice) stickyPrice.textContent = money(current.price);
        if (stickyVariant) stickyVariant.textContent = current.title || current.options.join(' / ');
        if (sku) sku.textContent = current.sku || '';
        if (skuWrap) skuWrap.hidden = !current.sku;
        if (add) { add.disabled = !current.available; add.textContent = current.available ? T.strings.addToBag : T.strings.soldOut; }
        if (stickyBtn) { stickyBtn.disabled = !current.available; stickyBtn.textContent = current.available ? T.strings.addToBag : T.strings.soldOut; }
        if (stock) { stock.className = 'stock-note ' + (current.available ? 'in' : 'out'); stock.textContent = current.available ? T.strings.inStock : T.strings.soldOutMore; }
        var gallery = $('#pdpGallery');
        var tiles = gallery ? $$('.pdp-image', gallery) : [];
        tiles.forEach(function (tile) { tile.classList.remove('is-variant-featured'); tile.removeAttribute('aria-current'); });
        var featured = current.featured_media || current.featured_image;
        var featuredId = variantMedia[String(current.id)] || (featured && featured.id);
        var featuredTile = null;
        if (featuredId) {
          featuredTile = tiles.find(function (tile) { return String(tile.getAttribute('data-media-id')) === String(featuredId); }) || null;
        }
        if (gallery) gallery.classList.toggle('has-variant-featured', Boolean(featuredTile));
        if (featuredTile) {
          featuredTile.classList.add('is-variant-featured');
          featuredTile.setAttribute('aria-current', 'true');
          if (window.matchMedia && window.matchMedia('(max-width: 540px)').matches) {
            requestAnimationFrame(function () { gallery.scrollTo({ left: 0, behavior: 'smooth' }); });
          }
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        if (add) { add.disabled = true; add.textContent = T.strings.soldOut; }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = T.strings.soldOut; }
      }
      refreshDisabled();
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.option-row [data-option-value]'); if (!btn) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var row = btn.closest('.option-row'), idx = parseInt(row.dataset.optionIndex, 10);
      selected[idx] = btn.dataset.optionValue;
      $$('[data-option-value]', row).forEach(function (b) { b.classList.remove('selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('selected'); btn.setAttribute('aria-pressed', 'true');
      var lbl = row.previousElementSibling && row.previousElementSibling.querySelector('span');
      if (lbl && /:/.test(lbl.textContent)) lbl.textContent = lbl.textContent.split(':')[0] + ': ' + btn.dataset.optionValue;
      refreshUI();
    });
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]'); if (!q) return;
      var inp = $('#Qty'); if (inp) inp.value = Math.min(9, Math.max(1, parseInt(inp.value || '1', 10) + parseInt(q.dataset.qty, 10)));
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available) { showToast(T.strings.soldOut); return; }
      addToCart(current.id, parseInt(($('#Qty') || {}).value || '1', 10));
    });
    var sticky = $('#stickyAdd'), addBtn = $('#pdpAddBtn');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('show', !entries[0].isIntersecting);
        sticky.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
      }, { rootMargin: '-60px 0px 0px 0px' }).observe(addBtn);
      var sBtn = $('[data-sticky-add]', sticky);
      if (sBtn) sBtn.addEventListener('click', function () { form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); });
    }
    refreshUI();
  })();

  /* ---------- zoom lightbox ---------- */
  var zoomIndex = 0, zoomSrcs = [];
  function openZoom(i) {
    zoomSrcs = $$('[data-zoom-open]', $('#pdpGallery')).map(function (trigger) {
      var img = $('img', trigger);
      return {
        src: trigger.getAttribute('data-zoom-src') || (img && (img.currentSrc || img.src)),
        alt: trigger.getAttribute('data-zoom-alt') || (img && img.alt) || 'Product image enlarged'
      };
    }).filter(function (item) { return item.src; });
    if (!zoomSrcs.length) return;
    zoomIndex = Math.min(i, zoomSrcs.length - 1);
    var m = $('#zoomModal'); m.classList.add('open'); m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lock');
    renderZoom(); trapFocus(m);
  }
  function resetZoom() {
    var stage = $('#zoomStage'), img = $('#zoomImg'), hint = $('#zoomHint');
    if (!stage || !img) return;
    img.classList.remove('is-zoomed');
    img.setAttribute('aria-pressed', 'false');
    img.setAttribute('aria-label', 'Click a point to zoom in');
    if (hint) hint.textContent = 'Scroll to explore · Click the image to zoom';
    stage.scrollLeft = 0;
    stage.scrollTop = 0;
  }
  function renderZoom() {
    var s = zoomSrcs[zoomIndex]; if (!s) return;
    var img = $('#zoomImg');
    resetZoom();
    img.src = s.src; img.alt = s.alt || 'Product image enlarged';
    $('#zoomCount').textContent = (zoomIndex + 1) + ' / ' + zoomSrcs.length;
    var prev = $('[data-zoom-prev]', $('#zoomModal')), next = $('[data-zoom-next]', $('#zoomModal'));
    if (prev) prev.hidden = zoomSrcs.length < 2;
    if (next) next.hidden = zoomSrcs.length < 2;
    announce('Image ' + (zoomIndex + 1) + ' of ' + zoomSrcs.length);
  }
  function stepZoom(d) { zoomIndex = (zoomIndex + d + zoomSrcs.length) % zoomSrcs.length; renderZoom(); }
  function togglePointZoom(e) {
    var img = $('#zoomImg'), stage = $('#zoomStage'), hint = $('#zoomHint');
    if (!img || !stage) return;
    if (img.classList.contains('is-zoomed')) {
      resetZoom();
      announce('Image returned to full view');
      return;
    }
    var rect = img.getBoundingClientRect();
    var pointX = e && typeof e.clientX === 'number' ? e.clientX : rect.left + rect.width / 2;
    var pointY = e && typeof e.clientY === 'number' ? e.clientY : rect.top + rect.height / 2;
    var ratioX = Math.max(0, Math.min(1, (pointX - rect.left) / rect.width));
    var ratioY = Math.max(0, Math.min(1, (pointY - rect.top) / rect.height));
    img.classList.add('is-zoomed');
    img.setAttribute('aria-pressed', 'true');
    img.setAttribute('aria-label', 'Click to return to the full image');
    if (hint) hint.textContent = 'Drag or scroll to explore · Click again to zoom out';
    requestAnimationFrame(function () {
      stage.scrollLeft = Math.max(0, ratioX * img.offsetWidth - stage.clientWidth / 2);
      stage.scrollTop = Math.max(0, ratioY * img.offsetHeight - stage.clientHeight / 2);
    });
    announce('Image zoomed in at the selected point');
  }
  function closeZoom() {
    var m = $('#zoomModal');
    if (m && m.classList.contains('open')) { resetZoom(); m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); releaseFocus(); }
    if (!$('.drawer.open') && !$('.modal.open') && !$('.search-panel.open')) document.body.classList.remove('lock');
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom-open]'); if (z) { openZoom(parseInt(z.dataset.zoomOpen, 10)); return; }
    if (e.target.closest('[data-zoom-prev]')) { stepZoom(-1); return; }
    if (e.target.closest('[data-zoom-next]')) { stepZoom(1); return; }
    if (e.target.closest('#zoomImg')) { togglePointZoom(e); return; }
    if (e.target.closest('#zoomModal [data-close]')) { closeZoom(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.id === 'zoomImg') {
      e.preventDefault(); togglePointZoom();
    }
  });

  /* ---------- quick add ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]'); if (!qa) return;
    var handle = qa.getAttribute('data-quick-add');
    fetch(T.routes.root + 'products/' + handle + '.js').then(function (r) {
      if (!r.ok) throw new Error('Product could not be loaded');
      return r.json();
    }).then(function (p) {
      var m = $('#quickModal'), body = $('#quickBody'); if (!m || !body) return;
      var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/, '_300x$1$2') : '';
      var html = '<div class="modal-top"><div class="modal-thumb">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
        '<div class="modal-meta"><h3>' + escapeHTML(p.title) + '</h3><p>' + money(p.price) + '</p></div></div>';
      if (p.variants.length === 1 && p.variants[0].title === 'Default Title') {
        html += '<button class="button dark block" data-qa-variant="' + p.variants[0].id + '"' + (p.variants[0].available ? '' : ' disabled') + '>' +
          (p.variants[0].available ? T.strings.addToBag : T.strings.soldOut) + '</button>';
      } else {
        html += '<div class="size-title"><span>' + escapeHTML(p.options.join(' / ')) + '</span></div><div class="size-grid">' +
          p.variants.map(function (v) {
            return '<button class="size-option' + (v.available ? '' : ' disabled') + '" data-qa-variant="' + v.id + '"' + (v.available ? '' : ' disabled aria-label="' + escapeHTML(v.title) + ' — out of stock"') + '>' + escapeHTML(v.title) + '</button>';
          }).join('') + '</div>';
      }
      body.innerHTML = html;
      m.classList.add('open'); m.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lock'); trapFocus(m.querySelector('.modal-card'));
    }).catch(function () { showToast('Product could not be loaded'); });
  });
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-qa-variant]'); if (!v || v.disabled) return;
    addToCart(v.getAttribute('data-qa-variant'), 1);
    closeEverything();
  });

  /* ---------- predictive search (with device-local recent searches) ---------- */
  function recents() { try { return JSON.parse(localStorage.getItem('ashenSearches')) || []; } catch (e) { return []; } }
  function rememberSearch(q) {
    q = (q || '').trim(); if (!q) return;
    var list = recents().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    try { localStorage.setItem('ashenSearches', JSON.stringify(list.slice(0, 5))); } catch (e) {}
  }
  function recentsHTML() {
    var list = recents(); if (!list.length) return '';
    return '<span>Recent</span>' + list.map(function (q) {
      return '<a class="search-chip" href="' + T.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">' + escapeHTML(q) + '</a>';
    }).join('');
  }
  function openSearch() {
    var p = $('#searchPanel'); if (!p) return;
    p.classList.add('open'); p.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lock');
    runPredictive('');
    setTimeout(function () { var i = $('#searchInput'); if (i) i.focus(); }, 50);
  }
  document.addEventListener('submit', function (e) {
    if (e.target.closest('.search-top')) rememberSearch(($('#searchInput') || {}).value);
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('#searchResults .search-item') || e.target.closest('#searchAll a')) rememberSearch(($('#searchInput') || {}).value);
  });
  var searchTimer;
  document.addEventListener('input', function (e) {
    if (e.target.id !== 'searchInput') return;
    clearTimeout(searchTimer);
    var q = e.target.value.trim();
    searchTimer = setTimeout(function () { runPredictive(q); }, 220);
  });
  function runPredictive(q) {
    var results = $('#searchResults'), empty = $('#searchEmpty'), all = $('#searchAll'), meta = $('#searchMeta');
    if (!results) return;
    if (!q) { results.innerHTML = ''; empty.hidden = true; all.innerHTML = ''; meta.innerHTML = recentsHTML(); return; }
    fetch(T.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
        meta.innerHTML = collections.length ? '<span>Collections</span>' + collections.map(function (c) {
          return '<a class="search-chip" href="' + c.url + '">' + escapeHTML(c.title) + '</a>';
        }).join('') : '';
        if (!products.length) {
          results.innerHTML = ''; all.innerHTML = '';
          empty.hidden = false;
          empty.textContent = 'No pieces match “' + q + '”. Check the spelling or try a simpler word.';
          return;
        }
        empty.hidden = true;
        results.innerHTML = products.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          return '<a class="search-item" href="' + p.url + '"><div class="search-thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div><b>' + escapeHTML(p.title) + '</b><div>' + (p.price ? money(parseFloat(p.price) * 100) : '') + '</div></a>';
        }).join('');
        all.innerHTML = '<a class="text-link" href="' + T.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">' + escapeHTML(T.strings.viewAll) + '</a>';
      })
      .catch(function () { /* predictive search unavailable — form submit still works */ });
  }

  /* ---------- recently viewed products (device-local) ---------- */
  (function () {
    var section = $('[data-recently-viewed]'); if (!section) return;
    var current = section.getAttribute('data-current-product');
    var grid = $('[data-recently-viewed-grid]', section);
    var viewed = [];
    try { viewed = JSON.parse(localStorage.getItem('ashenViewed')) || []; } catch (e) {}
    viewed = viewed.filter(function (handle) { return handle && handle !== current; }).slice(0, 4);

    if (viewed.length && grid) {
      Promise.all(viewed.map(function (handle) {
        return fetch(T.routes.root + 'products/' + handle + '.js').then(function (response) {
          return response.ok ? response.json() : null;
        }).catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        grid.innerHTML = products.map(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/, '_600x$1$2') : '';
          return '<article class="product-card"><div class="product-media-wrap"><a class="product-media" href="' + p.url + '">' +
            (img ? '<img class="main" src="' + img + '" alt="' + escapeHTML(p.title) + '" loading="lazy">' : '') +
            '</a></div><div class="product-info"><div class="product-name"><a href="' + p.url + '">' +
            escapeHTML(p.title) + '</a><span>' + money(p.price) + '</span></div></div></article>';
        }).join('');
        section.hidden = false;
      });
    }

    var next = [current].concat(viewed).filter(Boolean).slice(0, 5);
    try { localStorage.setItem('ashenViewed', JSON.stringify(next)); } catch (e) {}
  })();

  /* ---------- recommendations fallback fetch ---------- */
  (function () {
    var holder = $('[data-recommendations]'); if (!holder) return;
    fetch(holder.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('.related'); if (inner && inner.querySelector('.product-card')) holder.replaceWith(inner);
    }).catch(function () {});
  })();

  /* ---------- Shopify Customer Privacy API banner ---------- */
  (function () {
    var banner = $('#cookieBar');
    if (!banner || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error || !window.Shopify.customerPrivacy) return;
      var privacy = window.Shopify.customerPrivacy;
      if (privacy.shouldShowBanner()) banner.classList.add('show');
      banner.addEventListener('click', function (event) {
        var button = event.target.closest('[data-privacy-consent]'); if (!button) return;
        var allow = button.getAttribute('data-privacy-consent') === 'all';
        privacy.setTrackingConsent({
          analytics: allow,
          marketing: allow,
          preferences: allow,
          sale_of_data: allow
        }, function () {
          banner.classList.remove('show');
          showToast('Privacy preferences saved');
        });
      });
    });
  })();

  updateWishUI();
  fetchCart().then(function (c) { updateBagCount(c.item_count); }).catch(function () {});
})();
